<template>
  <div :class="['imageViewRoot',{'placeholderEnabled': placeholderFrame}, {'fitByHeight': this.fitByHeight}]">
    <div
      v-if="placeholderFrame"
      :style="placeholderStyle"
      :class="['placeholderFrame',{'enablePlaceholderBgColor': this.enablePlaceholderBgColor}]"></div>
    <div :class="['imageViewWrapper',{'placeholderFrameContent': placeholderFrame}]">
      <div class="imageView">
        <img
          v-if="lazyload"
          v-lazy="generateImageSrc(image, desiredSize, useBackEndSize)"
          :data-srcset="generateImgSrcSetString(image, desiredSize, useBackEndSize)"/>
        <img
          v-else
          :src="generateImageSrc(image, desiredSize, useBackEndSize)"
          :srcset="generateImgSrcSetString(image, desiredSize, useBackEndSize)"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {generateImageSrc, generateImgSrcSetString} from '../../utils/imageUtils';

  const MAX_WIDTH = 100;

  export default {
    name: "imageView",
    props: {
      lazyload: {
        type: Boolean,
        default: function () {
          return true;
        }
      },
      placeholderFrame: {
        type: Boolean,
        default: function () {
          return true;
        }
      },
      enablePlaceholderBgColor: {
        type: Boolean,
        default: function () {
          return true;
        }
      },
      image: {
        type: Object,
      },
      desiredSize: {
        type: Object,
        default: function () {
          return {};
        }
      },
      useBackEndSize: {
        type: Boolean,
      },
      fitByHeight: {
        type: Boolean,
      },
    },
    data() {
      return {};
    },
    computed: {
      placeholderStyle: function () {
        const imageSize = this.desiredSize
          || {
            width: this.image.width,
            height: this.image.height,
          }
          || {};

        return {
          paddingBottom: `${MAX_WIDTH / (imageSize.width / imageSize.height)}%`
        };
      },
    },
    methods: {
      generateImageSrc,
      generateImgSrcSetString,
    }
  };
</script>

<style src="./imageView.scss" lang="scss" scoped/>



// WEBPACK FOOTER //
// src/components/imageView/imageView.vue